// extracted by mini-css-extract-plugin
export default {"firstChild":"Notifications_firstChild__vi5bU","Row":"Notifications_Row__wlD+v","filter":"Notifications_filter__GTSfw","ListItem":"Notifications_ListItem__9BEOJ"};